import React, { useEffect, useState } from 'react'
import { Button, Card, Container, Row, Tab, Tabs } from 'react-bootstrap'
import { makeGetRequest } from '../../../../utils/api'
import { urls } from '../../../../utils/urls'
import LinkButton from '../../utils/LinkButton'

function WordSearch() {
    const [wordSearchURLs, setWordSearchURLs] = useState([])

    const handleData = async () => {
        const res = await makeGetRequest(urls.wordSearch + '?active=True',
            "",
            true)
        setWordSearchURLs(res.data)
    }

    useEffect(() => {
        if(wordSearchURLs.length === 0){
            handleData();
        }
    },[])

  return (
    <>
    <Container>
        {wordSearchURLs && wordSearchURLs.map((item) => {return (
                <Row key={item.id} style={{ marginTop: "25px" }}>
                    <Card style={{ padding: "5px" }}>
                        <LinkButton
                        buttonWidth="100%"
                        buttonHeight="88px"
                        buttonFontSize="26px"
                        title={item.name}
                        url={item.url}
                        />
                    </Card>
                </Row>
            );
        })}
    </Container>
    </>
  )
}

export default WordSearch